import React from "react";

const ProfileIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M10.1322 9.55841C10.0488 9.55008 9.94883 9.55008 9.85716 9.55841C7.87383 9.49175 6.29883 7.86675 6.29883 5.86675C6.29883 3.82508 7.94883 2.16675 9.99883 2.16675C12.0405 2.16675 13.6988 3.82508 13.6988 5.86675C13.6905 7.86675 12.1155 9.49175 10.1322 9.55841Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.96563 12.6333C3.94896 13.9833 3.94896 16.1833 5.96563 17.5249C8.25729 19.0583 12.0156 19.0583 14.3073 17.5249C16.324 16.1749 16.324 13.9749 14.3073 12.6333C12.024 11.1083 8.26562 11.1083 5.96563 12.6333Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;
